module.exports = __webpack_public_path__ + "img/081.eba7516d.jpeg";